var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CarouselBanner',{attrs:{"ga-action":'concert_banner_click',"banner-orin-data":_vm.bannerData,"banner-duration":_vm.bannerDuration}})}
var staticRenderFns = []

export { render, staticRenderFns }